import React from 'react';
import Designer from './Designer/Designer';
import {AppMenuItem} from '../../AppMenu/AppMenu';
import useProjectPriceObserver from '../../../Hooks/Project/useProjectPriceObserver';
import EditorHeader from '../../AppHeader/EditorHeader';

export type PhotobookProps = {
  onClickMenuItem: (item: AppMenuItem) => void;
};

const Photobook = ({onClickMenuItem}: PhotobookProps) => {
  const projectPrice = useProjectPriceObserver();

  return (
    <>
      <EditorHeader onClickItem={onClickMenuItem} projectPrice={projectPrice} />
      <Designer />
    </>
  );
};

export default Photobook;
